import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import { getPersonLabel } from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/TitleHolderInfo/TitleHolderInfo.utils';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { titleHolderPersonStyles, titleHoldersWrapperStyles } from './TitleHoldersSection.styles';
import { TitleHoldersSectionTestIds } from './TitleHoldersSection.testIds';

const TitleHoldersSection = ({
  borrowers,
  disabled,
  onTitleHolderAdd,
  onTitleHolderDelete,
  titleHolders,
}) => (
  <Box sx={titleHoldersWrapperStyles}>
    {[...borrowers, ...titleHolders].map(
      ({
        fullNameWithMiddleName,
        borrowerId,
        titleHolderId,
        borrowerType,
        orderNumber,
        isFieldsChanged,
      }) => (
        <Box
          data-title-holder-id={titleHolderId}
          key={borrowerId || titleHolderId}
          sx={titleHolderPersonStyles}
          onClick={onTitleHolderAdd}
        >
          <Box>
            <Typography color="text.secondary" display="block" variant="regular12">
              {getPersonLabel({ borrowerType, orderNumber })}
            </Typography>

            <Typography
              className="max-w-256 whitespace-break-spaces truncate"
              data-is-field-changed={isFieldsChanged}
              display="block"
              variant="regular14"
            >
              {fullNameWithMiddleName}
            </Typography>
          </Box>

          {!!titleHolderId && (
            <ButtonWithTooltip
              color="inherit"
              data-testid={TitleHoldersSectionTestIds.getDeleteButtonId(titleHolderId)}
              data-title-holder-id={titleHolderId}
              disabled={disabled}
              icon={DeleteIcon}
              iconButtonClassName="opacity-0 delete-title-holder-button ml-16"
              iconClassName="tool__disable-interaction"
              iconSize={IconSize[20]}
              title="Delete"
              onClick={onTitleHolderDelete}
            />
          )}
        </Box>
      ),
    )}
  </Box>
);

TitleHoldersSection.propTypes = {
  borrowers: PropTypes.array.isRequired,
  titleHolders: PropTypes.array.isRequired,
  onTitleHolderAdd: PropTypes.func.isRequired,
  onTitleHolderDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default memo(TitleHoldersSection);
